export default __webpack_public_path__ + "static/media/Group1765.b770e129.svg";